/** Small text helpers for the category plan. */

/** A number from text like "€1.2M", "350K" or "1,250,000"; null when unreadable. */
export function parseMoney(text: string): number | null {
    const m = text.replace(/[€$£,\s]/g, '').match(/^(\d+(?:\.\d+)?)([kmb])?$/i);
    if (!m) return null;
    const unit = {k: 1e3, m: 1e6, b: 1e9}[(m[2] ?? '').toLowerCase() as 'k' | 'm' | 'b'] ?? 1;
    return Number(m[1]) * unit;
}

/** Move a roadmap bar to `start`, keeping it inside quarters 1-12. */
export function placeBar(start: number, length: number): {start: number; length: number} {
    const len = Math.max(1, Math.min(12, Math.round(length)));
    return {start: Math.max(1, Math.min(13 - len, Math.round(start))), length: len};
}

/** A new id for an item added to a plan list, unique within `existing`. */
export function newId(prefix: string, existing: {id: string}[]): string {
    let i = existing.length + 1;
    while (existing.some(e => e.id === `${prefix}${i}`)) i++;
    return `${prefix}${i}`;
}
